import get from 'lodash/get';
import {useEffect,useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import {useGetCurrentProviderQuery} from '../../redux/services/providerApi';
import {useGetLeadsQuery} from '../../redux/services/leadApi';
import {setIsTableView} from '../../redux/reducers/leadTable';

import useUser from '../../hooks/useUser';
import useDebouncedState from '../../hooks/useDebouncedState';
import AppDashboard from '../AppDashboard';
import ListLeadsScreen from "../../components/leads/ListLeadsScreen";

const parseSearchParams = searchParams => {
  const allowedFields = [
    'status',
    'text',
    'provider_id',
    // 'contact_city',
    // 'contact_state',
    'provider__facility_id',
    'referral_category',
    'has_updates',
  ];
  let filters = allowedFields.reduce((acc, k) => {
    const val = searchParams.get(k);
    // include_nonowned_sessions should only be set if patient_id is also set
    if (val) {
      if (val === 'true') return {...acc, [k]: true};
      if (val === 'false') return {...acc, [k]: false};
      return {...acc, [k]: val};
    }
    return acc;
  }, {sort: '-date_created', include_metrics: true});
  if (!filters.status) filters.status = 'ACTIVE';
  return filters;
};

const handleFilter = ({setFilters, setSearchParams}) => filter => {
  setSearchParams(filter || {});
  setFilters(filter || {});
};

const ListLeadsPage = props => {
  // https://stackoverflow.com/questions/75522048/react-how-to-access-urls-parameters
  const {isAdmin} = props;
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState(parseSearchParams(searchParams));
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  const [pageIndex, setPageIndex] = useState(searchParams.get('pageIndex') || 0);
  const [pageSize, setPageSize] = useState(25);
  const dispatch = useDispatch();
  const isTableView = useSelector(state => state.leadTable.isTableView);
  const onFilterChange = handleFilter({setFilters, setSearchParams});
  const user = useUser();
  useEffect(() => {
    if (!isAdmin && user) {
      let _filters = {...filters, provider_id: user.provider.id};
      if (user?.provider?.facility?.id) _filters.provider__facility_id = user.provider.facility.id;
      onFilterChange(_filters);
    }
  }, [isAdmin, user]);
  useDebouncedState(filters, setDebouncedFilters, {delay: 500});
  const providerQuery = useGetCurrentProviderQuery();
  const query = useGetLeadsQuery(
      {skip: pageIndex.all * pageSize || 0, limit: pageSize, ...debouncedFilters}, 
      {skip: false}
  );
  const childProps = {
    ...props,
    isAdmin,
    // data
    rows: query?.data?.data,
    count: query?.data?.count || 0,
    metrics: query?.data?.metrics || {},
    isLoading: (
      providerQuery.isLoading
      || query?.isLoading
    ),
    isUpdating: query?.isFetching || query?.isLoading,
    // kanban vs table
    isTableView,
    setIsTableView: val => dispatch(setIsTableView(val)),
    // pagination
    pageIndex,
    pageSize,
    filters,
    // handlers
    onFilterChange,
    onPageChange: (e,num) => {
      setPageIndex(num);
      onFilterChange({...filters, skip: num * pageSize});
    },
    onRowsPerPageChange: e => setPageSize(parseInt(e.target.value, 100)),
  };
  return (
    <AppDashboard title='Leads' loading={childProps.isLoading} showTitle showHomeBtn>
      <ListLeadsScreen {...childProps} />
    </AppDashboard>
  );
};

export default ListLeadsPage;
